import { Directive, HostBinding } from '@angular/core';

@Directive({
  // tslint:disable:directive-selector
  selector: '[ls-dimmed]'
})
export class BodyDimmedDirective {
  @HostBinding('class.cr-text--dimmed') public dimmed = true;
}
